import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonToolTip from "components/common-component/Tooltip";
// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  ButtonBase,
  CardContent,
  ClickAwayListener,
  Grid,
  IconButton,
  Paper,
  Popper,
  Stack,
  Typography,
  Divider,
} from "@mui/material";

// project import
import MainCard from "components/MainCard";
import Transitions from "components/@extended/Transitions";
// assets

import Loadable from "components/Loadable";
import { LogoutOutlined } from "@ant-design/icons";
import {
  AI_getUserData,
  AI_get_feedbackCount,
  AI_global_search,
} from "APIs/user";
import { store } from "store";
import { AI_setWorkingProject } from "APIs/projectEmployee";
import { useInstance, useAIEventHandler } from "easy-redux-http-call";
import { Badge, Skeleton, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AdminNotification from "pages/Notification/AdminNotification";
import ProfileImage from "assets/images/icons/profile.svg";
import { AI_deleteNotification, AI_getNotification } from "APIs/notification";
import { debounce } from "lodash";
import GlobalSearchResult from "./GlobalSearchResult";
import SearchTextField from "components/common-component/SearchTextField";
import { useSelector } from "react-redux";
import LunchDiningIcon from "@mui/icons-material/LunchDining";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ReviewsIcon from "@mui/icons-material/Reviews";
import { AI_findParty, AI_getItem } from "APIs/partyOrder";
import { makeStyles } from "@mui/styles";
import ChangePassword from "pages/authentication/ResetPassword/ChangePassword";
import { ReactComponent as ResetPasswordIcon } from "assets/images/icons/resetPassword.svg";
import { useNavigate } from "react-router-dom";
import CommonButton from "components/common-component/Button";
import PunchInOrOut from "pages/PunchInOrOut/PunchInOrOut";
import MissPunch from "pages/PunchInOrOut/MissPunch";
import { AI_getProjectEmployeeList } from "APIs/projectEmployee";
// import { AI_getUserData } from "APIs/user";

import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { AI_getAnnouncementList } from "APIs/announcement";
import FeedBack from "./FeedBack";
import FeedBackConfirmationModal from "./FeedBackConfirmationModal";
import WorldClockDropdown from "components/common-component/WorldColck";
import { AI_taskAssingAndWorkingMember } from "APIs/projectTaskAssignment";
import ProjectNotes from "pages/Project/ProjectNotes";

const PartyResponsePopUp = Loadable(
  React.lazy(() => import("pages/PartyMenu/PartyResponsePopUp"))
);
const BugOrSuggestionPopUp = Loadable(
  React.lazy(() => import("./BugOrSuggestion"))
);
// tab panel wrapper
const useStyle = makeStyles((theme) => ({
  hrSearch: {
    flexShrink: 0,
    ml: 0.75,
    display: "flex",
    "& > svg": {
      marginRight: "11px",
      marginTop: "10px",
      cursor: "pointer",
      "& > path": {
        fill: "#ff7200",
      },
      // fontWeight: '500'
    },
  },
  hrSearchText: {
    marginTop: "4px",
  },
  hrNoti: {
    margin: "10px",
  },
  hrNotiIcon: {
    color: "#E27534",
    cursor: "pointer",
  },
  hrProfile: {
    width: 32,
    height: 32,
  },
  hrTranscition: {
    boxShadow: theme.customShadows.z1,
    width: 290,
    minWidth: 350,
    maxWidth: 290,
    [theme.breakpoints.down("md")]: {
      minWidth: 250,
    },
  },
  emailText: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  hrDivider: {
    borderBottom: 1,
    borderColor: "divider",
  },
}));
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const classes = useStyle();
  const theme = useTheme();

  const anchorRef = useRef(null);
  const anchorRef2 = useRef(null);

  // state
  const [open, setOpen] = useState(false);
  // const [openNotes,setOpenNotes] = useState(false);
  const [openNotes, setOpenNotes] = useState({
    open: false,
    id: null,
    notes: null,
    title: null,
  });
  
  const [readOnlyNotes, setReadOnlyNotes] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [globalSearch, setGlobalSearch] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [openBugPopUp, setOpenBugPopUp] = useState(false);
  const [openFeedbackPopUp, setOpenFeedbackPopUp] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    setOpenNotification(false);
    setGlobalSearch(false);
  };
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [search, setSearch] = useState(null);
  const [isLogOut, setIsLogOut] = React.useState(false);
  const [apiCall, setApiCall] = React.useState(false);
  const [punchInOrOut, setPunchInOrOut] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  // data from store
  const demo = useInstance(AI_global_search);
  const projectEmployeeReduxState = useInstance(AI_getProjectEmployeeList);
  const notificationReduxState = useInstance(AI_getNotification);
  const globaSearchReduxState = useInstance(AI_global_search);
  const getUserData = useInstance(AI_getUserData);
  const findParty = useInstance(AI_findParty);
  const getParty = useInstance(AI_getItem);
  const setWorkingPorject = useInstance(AI_setWorkingProject);
  const feedBackCount = useInstance(AI_get_feedbackCount);

  const navigate = useNavigate();

  const iconBackColorOpen = "grey.300";
  const page = useSelector((state) => state.menu.page);
  
  const [limit, setLimit] = useState(10);
  // close funcation for notification
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    setOpenNotification(false);
    setGlobalSearch(false);
  };
  // logout
  const handleLogout = async () => {
    if (getUserData?.data?.user?.is_login) {
      const currTaskId = localStorage.getItem("currentTaskId");
      const task_time = localStorage.getItem("stopwatch-time");
      const project_id = localStorage.getItem('projectId');
      await AI_taskAssingAndWorkingMember.call({
        params: {
          employee_id: getUserData?.data?.user?.employee_id,
          task_id: Number(currTaskId),
          is_working: false,
          task_time: task_time,
        },
      });
      await AI_taskAssingAndWorkingMember.call({
            params: {
              assigned_by: getUserData?.data?.user?.employee_id,
              employee_id: getUserData?.data?.user?.employee_id,
              project_id: project_id,
              task_id: Number(currTaskId),
              is_working: false,
            },
          });
      localStorage.removeItem("stopwatch-time");
      localStorage.removeItem("stopwatch-running");
      localStorage.removeItem("stopwatch-prevtime");
      
      setIsLogOut(true);
      await AI_setWorkingProject.call({
        params: {
          employee_id: getUserData?.data?.user?.employee_id,
          punchInOut: true // Punch-out when user Log out 
        },
      });
    
      // localStorage.removeItem('currentTaskId')
    } else {
      localStorage.clear();
      window.location.reload();
    }
  };

  // open funcation for notification pop-up
  const handleOpenNotification = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenNotification(!openNotification);
    setOpen(false);
  };

  useEffect(() => {
    const liveUserState = store.getState()?.userReducer?.userData;
    if (!liveUserState?.data && !liveUserState?.loading) {
      AI_getUserData.call();
    }
    AI_findParty.call();
    AI_getItem.call();
  }, []);

  useEffect(() => {
    if (getUserData?.data?.user?.is_admin) {
      AI_get_feedbackCount.call();
    }
  }, [getUserData?.data?.user?.is_admin]);
  // global search funcation
  const handleSearch = (event) => {
    setSearch(event.target.value);
    setGlobalSearch(true);
  };

  useEffect(() => {
    AI_getNotification.call();
  }, []);



  // debounce funcation for global search
  const debounceGlobalSearch = useCallback(
    debounce(
      (search) => {
        AI_global_search.call({
          params: {
            q: search,
          },
        });
      },
      [500]
    ),
    []
  );

  // call api for read notification
  useEffect(() => {
    if (openNotification && getUserData?.data?.user?.employee_id) {
      AI_deleteNotification.call({
        params: {
          employee_id: getUserData?.data?.user?.employee_id,
          user: getUserData?.data?.user?.type,
        },
      });
    }
  }, [openNotification]);

  // calling debounce funcation
  useEffect(() => {
    if (all_access) {
      debounceGlobalSearch(search);
    }
  }, [search]);

  useEffect(() => {
    setSearch("");
  }, [page]);
  const all_access =
    getUserData?.data?.user?.is_access_to_dashboard &&
    getUserData?.data?.user?.is_access_to_department &&
    getUserData?.data?.user?.is_access_to_employee &&
    getUserData?.data?.user?.is_access_to_project &&
    getUserData?.data?.user?.is_access_to_roles;

  useAIEventHandler(AI_setWorkingProject, {
    onSuccess: () => {
      if (isLogOut) {
        localStorage.clear();
        window.location.reload();
      }
    },
  });

  // check if user logged in wihtout setting a project
  var userLoggedIn = getUserData.data?.user?.is_login;
  if (userLoggedIn) {
    if (projectEmployeeReduxState.data && projectEmployeeReduxState.data.rows) {
      var allRowsNotWorking = projectEmployeeReduxState.data.rows.every(
        (row) => row.is_working === false
      );
    }
  }

  const handleClickFeedBackButton = () => {
    if (getUserData?.data?.user?.is_admin) {
      navigate("/feedback");
      localStorage.setItem("activeMenuItem", "feedback");
    } else {
      setOpenFeedbackPopUp(true);
    }
  };
  const handlePunchInOut = async (e) => {
    if(getUserData?.data?.user?.is_login){
      
    //   const task_time = localStorage.getItem('stopwatch-time')
    //   localStorage.setItem('endTaskTime',task_time);

    //   const currTaskId = localStorage.getItem("currentTaskId");
    //   localStorage.setItem('endTaskId',currTaskId);

    //  await AI_setWorkingProject.call({
    //     params: {
    //       employee_id: getUserData?.data?.user?.employee_id,
    //       punchInOut: true,
    //     },
    //   })
      // setApiCall(true)
      setOpenNotes(true)
      setOpenNotes({
                  open: true,
                  id: 1,
                  notes: null,
                  item: null,
                  title: "What did you work on during this session?",
                })
    }else{
      setPunchInOrOut(true)
    }
  }

 function getElapsedFormattedTime() {
    const start = localStorage.getItem("taskStart");
    const pausedDuration = parseInt(
      localStorage.getItem("pausedDuration") || "0",
      10
    );
    const pausedAt = parseInt(localStorage.getItem("pausedAt") || "0", 10);
    if (!start) return "00:00:00";
    let now = Date.now();
    const elapsed = now - parseInt(start) - pausedDuration;
    const totalSeconds = Math.floor(elapsed / 1000);

    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, "0");
    const minutes = Math.floor((totalSeconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");

    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }


    useEffect(()=>{
      if(getUserData?.data?.user?.is_login === false && apiCall){
        const task_time = getElapsedFormattedTime();
        const prev_task_id =  localStorage.getItem('endTaskId')
        const prev_task_time = localStorage.getItem('endTaskTime')
        const is_working = false;
    
          if(prev_task_id !== 'null' && prev_task_time !== 'null'){
              AI_taskAssingAndWorkingMember.call({
              params: {
                employee_id: getUserData?.data?.user?.employee_id,
                task_id: Number(prev_task_id),
                is_working: false,
                task_time: task_time,
              },
            });
          
            localStorage.removeItem("stopwatch-time");
            localStorage.removeItem("stopwatch-running");
            localStorage.removeItem("stopwatch-prevtime");
            localStorage.setItem("prevTaskId","null");
            localStorage.removeItem("currentTaskId");
            const prevTime = localStorage.getItem("taskStart")
            localStorage.setItem("stopwatch-prevtime",prevTime);
            setApiCall(false)
            }
        }
    },[getUserData])
  return (
    <Box className={classes.hrSearch}>
      {all_access && (
        <Grid ref={anchorRef2} className={classes.hrSearchText}>
          <SearchTextField search={search} handleSearch={handleSearch} />
        </Grid>
      )}
      {/* <Grid style={{ marginTop: "5px" }}>
        <WorldClockDropdown style={{position:"relative",marginRight:"10px" }}/>
      </Grid> */}
      {allRowsNotWorking && (
        <CommonToolTip title="You Are Punched-In without Selecting a Project">
          <ReportProblemIcon className={classes.icon} />
        </CommonToolTip>
      )}
      {!getUserData?.data?.user?.is_admin && (
        <Grid style={{ marginTop: "5px" }}>
          <CommonButton
            color={getUserData?.data?.user?.is_login ? "error" : "success"}
            loading={setWorkingPorject.loading}
            onClick={(event) =>
              handlePunchInOut(event)
            }
          >
            {getUserData?.data?.user?.is_login ? "Punch-Out" : "Punch-In"}
          </CommonButton>
        </Grid>
      )}
      {getUserData?.data?.user?.employee?.company_id === "ahmedabad" && !getParty?.data?.is_close && getParty?.error?.status !== false && (
        <Grid className={classes.hrNoti}>
          <Tooltip title="Party">
            <Badge color="success" variant="dot">
              <LunchDiningIcon
                className={classes.hrNotiIcon}
                onClick={() => setOpenMenu(true)}
              />
            </Badge>
          </Tooltip>
        </Grid>
      )}
      <Grid className={classes.hrNoti}>
        <Tooltip title="Feedback">
          <Badge color="success" badgeContent={feedBackCount?.data}>
            <ReviewsIcon
              className={classes.hrNotiIcon}
              onClick={(event) => handleClickFeedBackButton()}
            />
          </Badge>
        </Tooltip>
      </Grid>
      <Grid className={classes.hrNoti}>
        <Tooltip title="Suggestion">
          <QuestionMarkIcon
            className={classes.hrNotiIcon}
            onClick={(event) => setOpenBugPopUp(true)}
          />
        </Tooltip>
      </Grid>
      <Grid className={classes.hrNoti}>
        <Tooltip title="Notification">
          <Badge
            badgeContent={notificationReduxState?.data?.unread_notification}
            color="success"
          >
            <NotificationsIcon
              className={classes.hrNotiIcon}
              onClick={(event) => handleOpenNotification(event)}
            />
          </Badge>
        </Tooltip>
      </Grid>
      <Grid>
        <ButtonBase
          sx={{
            p: 0.25,
            bgcolor: open ? iconBackColorOpen : "transparent",
            borderRadius: 1,
            "&:hover": { bgcolor: "secondary.lighter" },
          }}
          aria-label="open profile"
          ref={anchorRef}
          aria-controls={open ? "profile-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            sx={{ p: 0.5 }}
          >
            {getUserData.loading ? (
              <Skeleton variant="circular" animation="wave">
                <Avatar />
              </Skeleton>
            ) : getUserData?.data?.user?.employee?.image ? (
              <Avatar
                alt="profile user"
                src={getUserData?.data?.user?.image_url}
                className={classes.hrProfile}
              />
            ) : (
              <Avatar
                alt="profile user"
                src={ProfileImage}
                className={classes.hrProfile}
              />
            )}
            <Typography variant="subtitle1">
              {getUserData?.data?.user?.username}
            </Typography>
          </Stack>
        </ButtonBase>
        <Popper
          placement="bottom-end"
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          popperOptions={{
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 9],
                },
              },
            ],
          }}
        >
          {({ TransitionProps }) => (
            <Transitions type="fade" in={open} {...TransitionProps}>
              {open && (
                <Paper className={classes.hrTranscition}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MainCard elevation={0} border={false} content={false}>
                      <CardContent sx={{ px: 2.5, pt: 3 }}>
                        <Grid
                          container
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Grid item>
                            <Stack
                              direction="row"
                              spacing={1.25}
                              alignItems="center"
                            >
                              {getUserData.loading ? (
                                <Skeleton variant="circular" animation="wave">
                                  <Avatar />
                                </Skeleton>
                              ) : getUserData?.data?.user?.employee?.image ? (
                                <Avatar
                                  alt="profile user"
                                  src={getUserData?.data?.user?.image_url}
                                  className={classes.hrProfile}
                                />
                              ) : (
                                <Avatar
                                  alt="profile user"
                                  src={ProfileImage}
                                  className={classes.hrProfile}
                                />
                              )}

                              <Stack>
                                <Typography
                                  onClick={() =>
                                    !getUserData?.data?.user?.is_admin &&
                                    navigate("/personal-details")
                                  }
                                  style={{
                                    cursor:
                                      !getUserData?.data?.user?.is_admin &&
                                      "pointer",
                                  }}
                                  variant="h6"
                                >
                                  {
                                    getUserData?.data?.user?.employee
                                      ?.first_name
                                  }{" "}
                                  {getUserData?.data?.user?.employee?.last_name}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                  className={classes.emailText}
                                >
                                  {getUserData?.data?.user?.employee?.email}
                                </Typography>
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item>
                            <IconButton
                              size="large"
                              color="secondary"
                              onClick={handleLogout}
                            >
                              <LogoutOutlined />
                            </IconButton>
                          </Grid>
                        </Grid>
                        <Divider style={{ marginTop: "20px" }} />
                        <Grid
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: "20px",
                          }}
                        >
                          <Grid
                            onClick={() => setOpenChangePassword(true)}
                            style={{ marginTop: "10px", cursor: "pointer" }}
                          >
                            Reset Password
                          </Grid>
                          <IconButton
                            size="medium"
                            color="secondary"
                            onClick={() => setOpenChangePassword(true)}
                          >
                            <ResetPasswordIcon
                              color="secondary"
                              width={24}
                              height={24}
                            />
                          </IconButton>
                        </Grid>
                      </CardContent>
                      {open && (
                        <>
                          <Box className={classes.hrDivider}>
                            {/* TODO Create Profile tab */}
                            {/* <Tabs
                              variant="fullWidth"
                              value={value}
                              onChange={handleChange}
                              aria-label="profile tabs"
                            >
                              <Tab
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textTransform: "capitalize",
                                }}
                                icon={
                                  <UserOutlined
                                    style={{
                                      marginBottom: 0,
                                      marginRight: "10px",
                                    }}
                                  />
                                }
                                label="Profile"
                                {...a11yProps(0)}
                              />
                              <Tab
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  textTransform: "capitalize",
                                }}
                                icon={
                                  <SettingOutlined
                                    style={{
                                      marginBottom: 0,
                                      marginRight: "10px",
                                    }}
                                  />
                                }
                                label="Setting"
                                {...a11yProps(1)}
                              />
                            </Tabs> */}
                          </Box>
                        </>
                      )}
                    </MainCard>
                  </ClickAwayListener>
                </Paper>
              )}
            </Transitions>
          )}
        </Popper>
      </Grid>
      {openNotification && (
        <AdminNotification
          open={openNotification}
          setOpen={setOpenNotification}
          data={notificationReduxState?.data?.all_notification?.rows}
          anchorEl={anchorRef.current}
          handleClose={handleClose}
        />
      )}
      {openMenu && (
        <PartyResponsePopUp
          openStatus={openMenu}
          handleCloseAction={() => setOpenMenu(false)}
          userId={getUserData?.data?.user?.employee?.id}
        />
      )}
      {openBugPopUp && (
        <BugOrSuggestionPopUp
          openStatus={openBugPopUp}
          handleCloseAction={() => setOpenBugPopUp(false)}
        />
      )}
      {search && (
        <GlobalSearchResult
          open={globalSearch}
          data={globaSearchReduxState?.data}
          anchorEl={anchorRef2.current}
          handleClose={handleClose}
          searchString={search}
        />
      )}

      {openChangePassword && (
        <ChangePassword
          openStatus={openChangePassword}
          handleCloseAction={() => setOpenChangePassword(false)}
        />
      )}
      {setWorkingPorject && (
        <PunchInOrOut
          openStatus={punchInOrOut}
          handleCloseAction={() => setPunchInOrOut(false)}
        />
      )}
      {getUserData?.data?.user?.is_forgot && (
        <MissPunch openStatus={getUserData.data.user.is_forgot} />
      )}
      {openFeedbackPopUp && (
        <FeedBack
          open={openFeedbackPopUp}
          handleCloseAction={() => setOpenFeedbackPopUp(false)}
          setOpenConfirmationModal={setOpenConfirmationModal}
        />
      )}
      {openConfirmationModal && (
        <FeedBackConfirmationModal
          open={openConfirmationModal}
          handleClose={() => setOpenConfirmationModal(false)}
        />
      )}
        {
          openNotes && (
            <ProjectNotes
            // display={false}
              component={"header"}
              readOnly={false}
              browseFile={true}
              // setIsreadOnly={(e) => setReadOnlyNotes((prev) => !prev)}
              openStatus={openNotes}
              handleCloseAction={() =>
                setOpenNotes({
                  open: false,
                  id: null,
                  notes: null,
                  title: null,
                })
              }
            />
          )
        }
                
                
    </Box>
  );
};

export default Profile;
